<template>
  <div>
    <div class="d-flex align-items-start main-page-stat">
      <b-img
        center
        class="w-50 main-page-stat-img"
        :src="imgSrc"
      />
    </div>
    <div class="text-center pt-2 font-large-1 font-weight-bold text-primary">
      {{ count }}
    </div>
    <div class="text-center pt-1">
      {{ name }}
    </div>
  </div>
</template>

<script>
import { BImg } from 'bootstrap-vue'

export default {
  name: 'ApplyDocStatisticsOneElementComponent',
  components: {
    BImg,
  },
  props: {
    imgSrc: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
}
</script>

<style>
  .main-page-stat {
    height: 90px;
  }
</style>
